import { render, staticRenderFns } from "./InqMember_M.vue?vue&type=template&id=c28d179e&scoped=true&"
import script from "./InqMember_M.vue?vue&type=script&lang=js&"
export * from "./InqMember_M.vue?vue&type=script&lang=js&"
import style0 from "./InqMember_M.vue?vue&type=style&index=0&id=c28d179e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d179e",
  null
  
)

component.options.__file = "InqMember_M.vue"
export default component.exports